import styles from "./Supplies.module.css";
import SuppliesItem from "../layout/SuppliesItem";
import racoes from "../../img/racoes.png";
import brinquedos from "../../img/brinquedos.png";
import coleira from "../../img/coleira.png";

function Supplies(props) {
  return (
    <section {...props} className={styles.sup_container}>
      <h2>Suprimentos</h2>
      <div className={styles.suppliesContainer}>
        <SuppliesItem
          to="/"
          titulo={"Rações"}
          image={racoes}
          altImage={"Rações"}
        />
        <SuppliesItem
          to="/"
          titulo={"Brinquedos"}
          image={brinquedos}
          altImage={"Brinquedos"}
        />
        <SuppliesItem
          to="/"
          titulo={"Coleiras"}
          image={coleira}
          altImage={"Coleiras"}
        />
      </div>
    </section>
  );
}

export default Supplies;
